import { Link, styled } from "@mui/material"
import { FormPinInputs } from "../../../form/input/FormPinInputs/FormPinInputs"
import { SecurityPrimaryButton } from "../common"
import { fields } from "./pinDialog.const"

interface PinDialogFormProps {
  validateAction: () => void
  onClickForgottenCode: () => void
}

export const PinDialogForm = ({
  validateAction,
  onClickForgottenCode,
}: PinDialogFormProps) => {
  return (
    <PinForm
      noValidate
      onSubmit={(e) => {
        e.preventDefault()
      }}
    >
      <FormPinInputs
        name={fields.password}
        slotProps={{ root: { sx: { justifyContent: "center" } } }}
      />
      <ForgottenCode onClick={onClickForgottenCode}>Code oublié ?</ForgottenCode>
      <SecurityPrimaryButton type="submit" onClick={validateAction}>
        Valider
      </SecurityPrimaryButton>
    </PinForm>
  )
}

const PinForm = styled("form")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1),
  alignItems: "center",
}))

const ForgottenCode = styled(Link)(({ theme }) => ({
  color: theme.palette.primary.main,
  alignSelf: "flex-start",
  cursor: "pointer",
}))
